<template>
	<footer class="footer">
		<div class="container-fluid">
			<div class="row">
				<div class="col-sm-6">v.1.0.6</div>
				<div class="col-sm-6">
					<div class="text-sm-right d-none d-sm-block">
						{{ year }} © Portal ASEIN.
					</div>
				</div>
			</div>
		</div>
	</footer>
</template>

<script>
   export default {
      name: 'FooterLayoutComponent',
      computed: {
         year () {
            var hoy = new Date();
            return hoy.getFullYear();
         }
      }
   }
</script>
